// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__tQ-Rk","obliqueLineWrap":"membershipbadge_obliqueLineWrap__24W_N","obliqueLine":"membershipbadge_obliqueLine__3lexX"};